module.exports = __webpack_public_path__ + "img/tutorial-pc-page2.725ddb5b.png";